// extracted by mini-css-extract-plugin
module.exports = {"title":"title-bNAviLucFH","hr":"hr-shVb4q_nYq","info-row2":"info-row2-hHxyENFtee","infoRow2":"info-row2-hHxyENFtee"};